var map = {
	"./V1.png": 6912,
	"./V2.png": 5243,
	"./V3.png": 8037,
	"./arrow.png": 4560,
	"./bgc.png": 4595,
	"./guide.png": 8531,
	"./onlineMode.png": 4807,
	"./openQrCodeBgc.png": 6173,
	"./picture0.png": 1161,
	"./picture1.png": 6688,
	"./picture2.png": 5019,
	"./picture3.png": 194,
	"./share_btn.png": 9351,
	"./top1.png": 9353,
	"./top2.png": 1170,
	"./top3.png": 2299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2736;